var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('span', [_c('img', { attrs: { "width": "80", "height": "80", "src": this.formValue[this.config.prop] || _vm.imageNotFound, "alt": "" } })]);
};
var staticRenderFns = [];

export { render, staticRenderFns };